import React from 'react'
import styles from './imagegrid.module.scss'
import { Link } from 'gatsby'
import FigureWithCaption from './FigureWithCaption.js'

export default props => {
  //Test to see if link is at root or route
  const path = props.route ? '/' + props.route + '/' : null

  const { images, numberOfColumns } = props

  const numberOfImages = images.length
  // const imagesPerColumn = Math.ceil(numberOfImages / numberOfColumns)

  //Set up multidimensional array to hold grid JSX
  let columns = []
  for (let i = 0; i < numberOfColumns; i++) {
    columns.push([])
  }

  let columnCursor = 1

  images.forEach((image, index) => {
    columns[columnCursor - 1].push(image)
    if (columnCursor === numberOfColumns) {
      columnCursor = 1
    } else {
      columnCursor++
    }
  })

  return (
    <div className={styles.imagegrid}>
      {columns.map((column, index) => (
        <div key={`col${index}`} className={styles.column}>
          {column.map((image, index) => (
            <Link
              className={styles.link}
              to={path ? path + image.id : image.id}
              key={index + image.Title}
            >
              <FigureWithCaption
                image={image.Image}
                title={image.Title}
                medium={image.Medium}
                sold={image.Sold}
                height={image.Height}
                width={image.Width}
              />
            </Link>
          ))}
        </div>
      ))}
    </div>
  )
}
